<!--
	Rule — horizontal hairline. Demoted from "the primary separation device" to an
	occasional one: on paper, space separates and a rule under every section just
	draws a ladder. Reach for it inside a block (above a footer row, between legal
	clauses), not between sections.

	`crop` adds registration-style end marks — the product's own registration-marks
	feature, echoed in the UI.
-->
<script lang="ts">
	let { crop = false, class: klass = '' }: { crop?: boolean; class?: string } = $props();
</script>

<div class="rule {klass}" class:rule--crop={crop} role="separator"></div>

<style>
	.rule {
		position: relative;
		height: 1px;
		width: 100%;
		background-color: var(--color-line);
	}
	.rule--crop::before,
	.rule--crop::after {
		content: '';
		position: absolute;
		top: -3px;
		height: 7px;
		width: 1px;
		background-color: var(--color-line-strong);
	}
	.rule--crop::before {
		left: 0;
	}
	.rule--crop::after {
		right: 0;
	}

	:global(.sec--dark) .rule,
	:global(.app-surface) .rule {
		background-color: var(--color-app-700);
	}
	:global(.sec--dark) .rule--crop::before,
	:global(.sec--dark) .rule--crop::after {
		background-color: var(--color-app-500);
	}
</style>
